<template>
  
  <transition name="fade" mode="out-in">
    <router-view ></router-view>
  </transition>

</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      
    }
  },
  methods: {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 定义 fade 过渡的状态 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
